import { DateFields, Services } from '@sigma-frontend-libs/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services['url-shortener-tracking'],

      backendGeneration: 'nest',

      find: {
        defaultFilter: {
          domain: undefined,
          clientIp: undefined,
          order: [ [ DateFields.createdAt, OrderDirections.DESC ] ]
        }
      },

      create: false,
      remove: false,
      update: false,

      has: {
        tabs: false,
        clone: false,
        search: false,
        support: false
      },

      formClass: ''
    })
  ]
}
